exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh2[data-v-f077b3fc] {\n    text-transform: uppercase;\n}\n", ""]);

// exports
